"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _lodash = _interopRequireDefault(require("lodash.get"));

var _uiKit = require("@devsta/ui-kit");

var _commonReact = require("@devsta/common-react");

var _CostFooter = _interopRequireDefault(require("../../CostFooter"));

require("../styles/_master-output.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function MasterOutput(_ref) {
  var versions = _ref.versions,
      onChangeAddon = _ref.onChangeAddon,
      canUpdateOutput = _ref.canUpdateOutput,
      getAddonsCost = _ref.getAddonsCost;
  var appliedAddons = versions[0].appliedAddons;
  var estimatedCost = getAddonsCost(appliedAddons, {
    isMaster: true
  });
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "master-output"
  }, /*#__PURE__*/_react.default.createElement(_uiKit.Text, {
    className: "master-output__heading",
    heading4: true,
    suffixDagger: true
  }, "Select from the options below"), /*#__PURE__*/_react.default.createElement("div", {
    className: "master-output__addons"
  }, /*#__PURE__*/_react.default.createElement(_commonReact.ExpandableRushEdit, {
    rushEdit: (0, _lodash.default)(appliedAddons, 'RUSH_EDIT.value'),
    onChangeAddon: onChangeAddon,
    disabled: !canUpdateOutput
  }), /*#__PURE__*/_react.default.createElement(_commonReact.ExpandableBurnInCaptions, {
    onChangeAddon: onChangeAddon,
    burnInCaptions: (0, _lodash.default)(appliedAddons, 'BURN_IN_CAPTIONS.value'),
    disabled: !canUpdateOutput
  }), /*#__PURE__*/_react.default.createElement(_commonReact.ExpandableSrtCaptions, {
    onChangeAddon: onChangeAddon,
    srtCaptions: (0, _lodash.default)(appliedAddons, 'SRT_CAPTIONS'),
    disabled: !canUpdateOutput
  }), /*#__PURE__*/_react.default.createElement(_commonReact.ExpandableDuration, {
    duration: (0, _lodash.default)(appliedAddons, 'DURATION.value'),
    onChangeAddon: onChangeAddon,
    disabled: !canUpdateOutput
  }), /*#__PURE__*/_react.default.createElement(_commonReact.ExpandableChromaKey, {
    chromaKey: (0, _lodash.default)(appliedAddons, 'CHROMA_KEY.value'),
    onChangeAddon: onChangeAddon,
    disabled: !canUpdateOutput
  })), /*#__PURE__*/_react.default.createElement(_CostFooter.default, {
    cost: estimatedCost,
    secondaryText: "Prices & currency are based on your organisation's billing region.",
    tertiaryText: "Included in your package."
  }));
}

var _default = /*#__PURE__*/(0, _react.memo)(MasterOutput);

exports.default = _default;